import { cmsBuilder } from '@pages/PKCS7Component/modules/crypto-client';

export const useGeneratePCKS7 = () => {
  /**
   *
   * @param cert
   * @param key
   * @param pass
   * @param hash
   *
   * @example
   * const p7b64 = pkcs7(user_certBuffer, user_keyBuffer, '123456', '1a39e212dfac89d3ae7a85ced820caa48a09e8303e11dd53cf5c58f2b0a2b526')
   * @returns
   */
  const pkcs7 = (hash: string, cert: any, key: any, pass: string) => {
    const cmsParams = {
      signer: {
        keys: [
          {
            id: 'UserKey',
            keyInfo: { cert, privK: key, pass },
          },
        ],
      },
      certsACs: [],
    };

    const gen = new cmsBuilder(cmsParams);
    const b64CMS = gen.generateDataSigned(
      true /*externalSignatures*/,
      'UserKey' /*idKey*/,
      'sha256',
      hash,
      'base64' /*encode*/,
    );

    return b64CMS;
  };

  return {
    pkcs7,
  };
};
